import React, { useCallback } from 'react';
import classnames from 'classnames/bind';
import Title from "../../../../Title";
import { defaultPropObject } from "../../../../constants";
import { ChevronNormalDown } from "../../../../icons";
import { Markup } from "../../../../internal/Markup";
import { TextBase } from "../../../../internal/TextBase";
import { keyCode } from "../../../../utils/keyCodes";
import styles from './MobileAccordionItem.css';
var cx = classnames.bind(styles);
export var MobileAccordionItem = function MobileAccordionItem(_ref) {
  var children = _ref.children,
      onOpenChange = _ref.onOpenChange,
      open = _ref.open,
      subtitle = _ref.subtitle,
      title = _ref.title,
      _ref$classes = _ref.classes,
      classes = _ref$classes === void 0 ? defaultPropObject : _ref$classes;
  var handleToggle = useCallback(function () {
    onOpenChange(!open);
  }, [onOpenChange, open]);
  var handleKeyDown = useCallback(function (event) {
    if (event.keyCode === keyCode.ENTER || event.keyCode === keyCode.SPACE) {
      handleToggle();
    }
  }, [handleToggle]);
  return /*#__PURE__*/React.createElement("div", {
    className: cx('root', classes.root)
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('head'),
    onClick: handleToggle,
    role: "button",
    tabIndex: 0,
    onKeyDown: handleKeyDown
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('title')
  }, /*#__PURE__*/React.createElement(Title, {
    level: 3
  }, /*#__PURE__*/React.createElement(Markup, {
    text: title
  })), /*#__PURE__*/React.createElement("span", {
    className: cx('expand-icon', {
      opened: open
    })
  }, /*#__PURE__*/React.createElement(ChevronNormalDown, null))), !open && /*#__PURE__*/React.createElement(TextBase, {
    as: "span",
    color: "N80",
    noWrap: true,
    size: "s",
    display: "inline-block"
  }, /*#__PURE__*/React.createElement(Markup, {
    text: subtitle
  }))), open && /*#__PURE__*/React.createElement("div", {
    className: cx('content')
  }, children));
};